import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';

import ModalLogin from './ModalLogin';
import ModalDownload from './ModalDownload';
import { cancelSharedWorkoutDownload, sharedWorkoutModal } from '../ducks/sharedWorkoutActions';
import ModalCreateAccount from './ModalCreateAccount';

const ModalOverlay = styled('div')`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

const ModalHandler = () => {
  const activeModal = useSelector((state) => state.sharedWorkout.ui.activeModal);
  const isDownloadButtonClicked = useSelector(
    (state) => state.sharedWorkout.ui.isDownloadButtonClicked,
  );

  const dispatch = useDispatch();

  const closeModal = () => {
    dispatch(cancelSharedWorkoutDownload());
    dispatch(sharedWorkoutModal(''));
  };

  const setModal = (modal) => {
    dispatch(sharedWorkoutModal(modal));
  };

  if (activeModal) {
    return (
      <>
        {activeModal === 'login' ? (
          <>
            <ModalOverlay onClick={closeModal} />
            <ModalLogin setModal={setModal} />
          </>
        ) : null}
        {activeModal === 'download' && isDownloadButtonClicked
          ? (
            <>
              <ModalOverlay onClick={closeModal} />
              <ModalDownload closeModal={closeModal} />
            </>
          )
          : null}
        {activeModal === 'createAccount' ? (
          <>
            <ModalOverlay onClick={closeModal} />
            <ModalCreateAccount setModal={setModal} />
          </>
        ) : null}
      </>
    );
  }
  return null;
};
export default ModalHandler;
